import classnames from 'classnames'
import { useMemo, useState } from 'react'

import { Popup, StatusGuideExpansionSection, Button, IconHelpCircle } from '@/components'
import { useAnalytics } from '@/hooks'
import { SystemStatusCategory, InverterManufacturer } from '@/models'

type StatusGuidePopupProps = {
    compact?: boolean
}

const StatusGuidePopup = ({ compact }: StatusGuidePopupProps) => {
    const [showPopup, setShowPopup] = useState(false)
    const { trackEvent } = useAnalytics()

    const systemCategories = useMemo(() => SystemStatusCategory.all, [])

    const handleClick = () => {
        trackEvent('popup_open', 'monitoring', 'Status Guide Popup')
        setShowPopup(true)
    }

    return <>
        <span role="button" tabIndex={-1}>
            <Button design="btn-link" onClick={handleClick} data-test="monioring-index-status-guide-button">
                {compact
                    ? <IconHelpCircle className="stroke-gray-400 hover:stroke-primary-800"/>
                    : <span className="text-sm text-primary-800 font-normal p-4 pl-0 md:p-0">
                        View Status Guide
                    </span>}
            </Button>
        </span>
        <Popup
            open={showPopup}
            onClose={() => setShowPopup(false)}
            className="w-225"
        >
            <div className="p-4 text-sm">
                <h3 className="flex items-center gap-3 mb-6 font-semibold text-xl font-display">
                    Site Status Guide
                </h3>
                <div className="text-sm font-body text-gray-600">
                    <p>
                        Solar Insure reports system or component level errors based on the inverter manufacturer&apos;s
                        monitoring data. These issues help identify potential problems in your solar system.
                    </p>
                </div>
                <div className="flex items-center gap-4 mt-6">
                    <p className="font-semibold text-gray-600 text-xs">Supported Inverter Manufacturers</p>
                    <div className="self-end">
                        <div className="flex">
                            {InverterManufacturer.allSupported.map((item, index) =>
                                <div
                                    key={item.key}
                                    className={classnames(
                                        'p-1.5 rounded-full border border-gray-300 bg-white hover:z-10',
                                        { '-ml-1.5': index }
                                    )}
                                >
                                    {item.getLogo()}
                                </div>)}
                        </div>
                    </div>
                </div>

                {systemCategories.map(item =>
                    <StatusGuideExpansionSection
                        key={item.value}
                        statusCategory={item}
                    />)}
            </div>
        </Popup></>
}

export default StatusGuidePopup
